// NonGRAllImageUpload.jsx

import React, { useEffect, useState, useRef } from 'react';
import {
  Dimensions,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
  TextInput,
  TouchableOpacity,
  ScrollView,
  Modal,
  Image,
  ActivityIndicator,
  Alert,
  FlatList,
} from 'react-native';
import { Picker } from '@react-native-picker/picker';
import axios from 'axios';
import { Formik } from 'formik';
import * as yup from 'yup';

import { BASE_URL } from '../../../components/BaseUrl';
import LeftBar from '../../../shared/LeftBar';
import ErrorText from '../../../shared/errorText';
import { globalStyles } from '../../../styles/globalStyles';
import moment from 'moment';

import { DatePickerModal } from 'react-native-paper-dates';
import { ThemeOne } from '../../../utils/constants/Colors';
import { useRoute } from '@react-navigation/native';
import LeftBarItemAdmin from '../../../shared/LeftBarItemAdmin';
import { adminMenus } from '../../../shared/adminMenus';

const COURT_TYPE_DISTRICT = [
  {
    id: '3',
    name: 'চীফ জুডিসিয়াল ম্যাজিস্ট্রেট আদালত',
    officeOriginIds: [14, 15, 16, 17, 84, 85, 91, 95],
    type: '1',
  },
  {
    id: '2',
    name: 'জেলা জজ আদালত',
    officeOriginIds: [4, 5, 6, 7, 8, 18, 19, 20, 21, 74, 75, 76, 83, 94, 103, 105],
    type: '1',
  },
  {
    id: '4',
    name: 'ট্রাইবুনালসমূহ',
    officeOriginIds: [89, 9, 72, 73, 77, 79, 80, 81, 82, 86, 87, 96, 102, 104, 110, 111, 112],
    type: '1',
  },
];

const COURT_TYPE_METRO = [
  {
    id: '6',
    name: 'চীফ মেট্রোপলিটন ম্যাজিস্ট্রেট আদালত',
    officeOriginIds: [13, 22, 23, 24, 78, 92, 100],
    type: '2',
  },
  { id: '5', name: 'মহানগর দায়রা জজ আদালত', officeOriginIds: [10, 11, 12, 88], type: '2' },
  { id: '7', name: 'বিশেষ ট্রাইব্যুনাল', officeOriginIds: [109], type: '2' },
];

const METRO_DISTRICT_IDS = [65, 66, 67, 68, 69, 70];
const Colors2 = ThemeOne;
const windowWidth = Dimensions.get('window').width;
const isWideWeb = Platform.OS === 'web' && windowWidth >= 600;

// চীফ জুডিসিয়াল ম্যাজিস্ট্রেট আদালত (id: 3) এবং চীফ মেট্রোপলিটন ম্যাজিস্ট্রেট আদালত (id: 6)
const CHIEF_COURT_IDS = ['3', '6'];

const basicInfoSchema = yup.object({
  divisionName: yup.string().required('Division is required'),
  districtName: yup.string().required('District is required'),
  grBranchId: yup.string().required('Lower Court is required'),
  nameBng: yup.string().required('Thana/Area name is required'),
});

export const NonGRAllImageUploadComponent = () => {
  const route = useRoute();
  const locale = 'en';
  const pastDate = new Date(1900, 0, 1);
  const futureDate = new Date();

  // Geo/location dropdown data
  const [divisions, setDivisions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [lowerCourts, setLowerCourts] = useState([]);
  const [thanas, setThanas] = useState([]);

  // Create-form selections
  const [divisionId, setDivisionId] = useState('');
  const [districtId, setDistrictId] = useState('');
  const [courtTypeId, setCourtTypeId] = useState('');
  const [thanaId, setThanaId] = useState('');
  const [causeDate, setCauseDate] = useState(new Date());
  const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);

  // Image upload states
  const [selectedImages, setSelectedImages] = useState([]);
  const [uploadingImages, setUploadingImages] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});

  const [allData, setAllData] = useState([]);
  const [searchDivisionId, setSearchDivisionId] = useState('');
  const [searchDistrictId, setSearchDistrictId] = useState('');
  const [searchThanaId, setSearchThanaId] = useState('');
  const [searchCauseDate, setSearchCauseDate] = useState(new Date());
  const [isSearchDatePickerVisible, setIsSearchDatePickerVisible] = useState(false);

  const [editDistricts, setEditDistricts] = useState([]);
  const [editLowerCourts, setEditLowerCourts] = useState([]);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editDivisionId, setEditDivisionId] = useState('');
  const [editDistrictId, setEditDistrictId] = useState('');
  const [editLowerCourtId, setEditLowerCourtId] = useState('');
  const [editLowerCourtName, setEditLowerCourtName] = useState('');

  const [isImageEditModalVisible, setIsImageEditModalVisible] = useState(false);
  const [editingImage, setEditingImage] = useState(null);
  const [uploadingUpdateImage, setUploadingUpdateImage] = useState(false);
  const [selectedUpdateImage, setSelectedUpdateImage] = useState(null);

  // ─── GetCourtImagesGrouped (tree: parent lower-court → child images) ───────
  const [loadingCourtImages, setLoadingCourtImages] = useState(false);
  const [courtsWithImages, setCourtsWithImages] = useState([]);
  const [courtsWithoutImages, setCourtsWithoutImages] = useState([]);
  const [expandedCourtIds, setExpandedCourtIds] = useState({});
  const [expandedDiaryIds, setExpandedDiaryIds] = useState({});
  const [courtTypes, setCourtTypes] = useState([]);
  const [isChiefCourtMode, setIsChiefCourtMode] = useState(false);

  // Upload modal for a specific lower court (parent) + cause_date
  const [isCourtUploadModalVisible, setIsCourtUploadModalVisible] = useState(false);
  const [uploadTargetCourt, setUploadTargetCourt] = useState(null);
  const [uploadTargetDiary, setUploadTargetDiary] = useState(null);
  const [courtUploadImages, setCourtUploadImages] = useState([]);
  const [uploadingCourtImages, setUploadingCourtImages] = useState(false);

  // Image Viewer Modal states
  const [isImageViewerVisible, setIsImageViewerVisible] = useState(false);
  const [viewerImages, setViewerImages] = useState([]);
  const [viewerCurrentIndex, setViewerCurrentIndex] = useState(0);
  const [viewerTitle, setViewerTitle] = useState('');
  const [zoomLevel, setZoomLevel] = useState(1);
  const [zoomPan, setZoomPan] = useState({ x: 0, y: 0 });
  const [isZooming, setIsZooming] = useState(false);
  const [touchStart, setTouchStart] = useState({ x: 0, y: 0 });

  // Refs for drag and drop
  const dropzoneRef = useRef(null);
  const updateDropzoneRef = useRef(null);
  const courtDropzoneRef = useRef(null);

  useEffect(() => {
    fetchDivisions();
    fetchAllData();
  }, []);

  // ─── Date pickers ───────────────────────────────────────────────────────────

  const showDatePicker = () => setIsDatePickerVisible(true);
  const hideDatePicker = () => setIsDatePickerVisible(false);
  const handleDateConfirm = ({ date }) => {
    setCauseDate(date);
    hideDatePicker();
  };

  const showSearchDatePicker = () => setIsSearchDatePickerVisible(true);
  const hideSearchDatePicker = () => setIsSearchDatePickerVisible(false);
  const handleSearchDateConfirm = ({ date }) => {
    setSearchCauseDate(date);
    hideSearchDatePicker();
  };

  // ─── API: geo dropdowns ─────────────────────────────────────────────────────

  const fetchDivisions = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/GetDivission`);
      setDivisions(response.data || []);
    } catch (error) {
      console.log('Division Error:', error);
    }
  };

  const fetchDistrictsByDivision = async divisionId => {
    try {
      const formBody = `division_id=${encodeURIComponent(divisionId)}`;
      const response = await axios.post(`${BASE_URL}/DivisionToDistrict`, formBody, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      setDistricts(response.data || []);
      setThanaId('');
      setCourtTypeId('');
      setLowerCourts([]);
    } catch (error) {
      console.log('District Error:', error);
    }
  };

  const fetchEditDistrictsByDivision = async divisionId => {
    try {
      const formBody = `division_id=${encodeURIComponent(divisionId)}`;
      const response = await axios.post(`${BASE_URL}/DivisionToDistrict`, formBody, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      setEditDistricts(response.data || []);
    } catch (error) {
      console.log('District Error:', error);
    }
  };

  const fetchLowerCourtsByDistrict = async districtId => {
    setLowerCourts([]);
    try {
      const params = { geo_division_id: divisionId, geo_district_id: districtId, status: 1 };
      const response = await axios.get(`${BASE_URL}/GetGrbranchByDivisionAndDistrict`, {
        params,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      setLowerCourts(response.data || []);
      setThanaId('');
      setCourtTypeId('');
    } catch (error) {
      console.log('Lower Court Error:', error);
    }
  };

  const fetchThanasByBranch = async branchId => {
    try {
      const params = {
        geo_division_id: divisionId,
        geo_district_id: districtId,
        gr_branch_id: branchId,
        status: 1,
      };
      const response = await axios.get(`${BASE_URL}/GetAllPoliceStation`, {
        params,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      setThanas(response.data || []);
    } catch (error) {
      console.log('Thana Error:', error);
    }
  };

  const fetchEditLowerCourtsByDistrict = async districtId => {
    try {
      const params = { geo_division_id: editDivisionId, geo_district_id: districtId, status: 1 };
      const response = await axios.get(`${BASE_URL}/GetAllPoliceStation`, {
        params,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      setEditLowerCourts(response.data || []);
      setEditLowerCourtId('');
      setEditLowerCourtName('');
    } catch (error) {
      console.log('Lower Court Error:', error);
    }
  };

  // ─── API: GetCourtImagesGrouped / GetCourtThanaImagesGrouped ──────────────

  const fetchCourtImagesGrouped = async () => {
    if (!causeDate) {
      alert('তারিখ নির্বাচন করুন');
      return;
    }
    if (!divisionId) {
      alert('বিভাগ নির্বাচন করুন');
      return;
    }
    if (!districtId) {
      alert('জেলা নির্বাচন করুন');
      return;
    }
    if (!courtTypeId) {
      alert('আদালতের ধরণ নির্বাচন করুন');
      return;
    }

    setLoadingCourtImages(true);
    setExpandedCourtIds({});
    setExpandedDiaryIds({});

    try {
      const payload = {
        geo_division_id: divisionId ? Number(divisionId) : null,
        geo_district_id: districtId ? Number(districtId) : null,
        building_name_id: courtTypeId ? Number(courtTypeId) : null,
        cause_date: moment(causeDate).format('YYYY-MM-DD'),
      };

      const isChiefCourt = CHIEF_COURT_IDS.includes(courtTypeId);
      setIsChiefCourtMode(isChiefCourt);

      const endpoint = isChiefCourt
        ? `${BASE_URL}/GetCourtThanaImagesGrouped`
        : `${BASE_URL}/GetCourtImagesGrouped`;

      const response = await axios.post(endpoint, payload);

      if (isChiefCourt) {
        const data = response.data;
        setCourtsWithImages(data.withImages || []);
        setCourtsWithoutImages(data.withoutImages || []);
        
        const allDiaryIds = {};
        [...(data.withImages || []), ...(data.withoutImages || [])].forEach(court => {
          [...(court.diariesWithImages || []), ...(court.diariesWithoutImages || [])].forEach(diary => {
            allDiaryIds[diary.diary_id] = true;
          });
        });
        setExpandedDiaryIds(allDiaryIds);
      } else {
        const data = response.data;
        setCourtsWithImages(data.withImages || []);
        setCourtsWithoutImages(data.withoutImages || []);
      }
    } catch (error) {
      console.log('GetCourtImagesGrouped Error:', error);
      alert('তথ্য আনতে সমস্যা হয়েছে');
    } finally {
      setLoadingCourtImages(false);
    }
  };

  const toggleCourtExpand = lowerCourtId => {
    setExpandedCourtIds(prev => ({ ...prev, [lowerCourtId]: !prev[lowerCourtId] }));
  };

  const toggleDiaryExpand = diaryId => {
    setExpandedDiaryIds(prev => ({ ...prev, [diaryId]: !prev[diaryId] }));
  };

  // ─── Image Viewer Functions ────────────────────────────────────────────────

  const openImageViewer = (images, index, title) => {
    setViewerImages(images);
    setViewerCurrentIndex(index);
    setViewerTitle(title);
    setZoomLevel(1);
    setZoomPan({ x: 0, y: 0 });
    setIsImageViewerVisible(true);
  };

  const closeImageViewer = () => {
    setIsImageViewerVisible(false);
    setZoomLevel(1);
    setZoomPan({ x: 0, y: 0 });
  };

  const goToViewerPrevious = () => {
    setViewerCurrentIndex(prev => (prev > 0 ? prev - 1 : viewerImages.length - 1));
    setZoomLevel(1);
    setZoomPan({ x: 0, y: 0 });
  };

  const goToViewerNext = () => {
    setViewerCurrentIndex(prev => (prev < viewerImages.length - 1 ? prev + 1 : 0));
    setZoomLevel(1);
    setZoomPan({ x: 0, y: 0 });
  };

  const handleZoomIn = () => {
    setZoomLevel(prev => Math.min(prev + 0.5, 3));
  };

  const handleZoomOut = () => {
    setZoomLevel(prev => Math.max(prev - 0.5, 0.5));
  };

  const handleZoomReset = () => {
    setZoomLevel(1);
    setZoomPan({ x: 0, y: 0 });
  };

  // Touch events for zoom and pan
  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    setTouchStart({ x: touch.clientX, y: touch.clientY });
    setIsZooming(true);
  };

  const handleTouchMove = (e) => {
    if (!isZooming || zoomLevel <= 1) return;
    e.preventDefault();
    const touch = e.touches[0];
    const deltaX = touch.clientX - touchStart.x;
    const deltaY = touch.clientY - touchStart.y;
    setZoomPan(prev => ({
      x: prev.x + deltaX,
      y: prev.y + deltaY,
    }));
    setTouchStart({ x: touch.clientX, y: touch.clientY });
  };

  const handleTouchEnd = () => {
    setIsZooming(false);
  };

  // Wheel zoom for web
  const handleWheel = (e) => {
    e.preventDefault();
    if (e.deltaY < 0) {
      handleZoomIn();
    } else {
      handleZoomOut();
    }
  };

  // ─── Upload modal for a specific lower court + cause_date ───────────────────

  const openCourtUploadModal = (court, diary = null) => {
    setUploadTargetCourt(court);
    setUploadTargetDiary(diary);
    setCourtUploadImages([]);
    setIsCourtUploadModalVisible(true);
  };

  const closeCourtUploadModal = () => {
    courtUploadImages.forEach(img => img.preview && URL.revokeObjectURL(img.preview));
    setIsCourtUploadModalVisible(false);
    setUploadTargetCourt(null);
    setUploadTargetDiary(null);
    setCourtUploadImages([]);
  };

  const handleCourtUploadImageSelect = event => {
    const newImages = mapFilesToImageState(Array.from(event.target.files));
    setCourtUploadImages(prev => [...prev, ...newImages]);
  };

  const handleCourtUploadDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    const imageFiles = files.filter(file => file.type.startsWith('image/'));
    if (imageFiles.length > 0) {
      const newImages = mapFilesToImageState(imageFiles);
      setCourtUploadImages(prev => [...prev, ...newImages]);
    }
  };

  const handleCourtUploadDragOver = (e) => {
    e.preventDefault();
  };

  const removeCourtUploadImage = imageId => {
    setCourtUploadImages(prev => {
      const removed = prev.find(img => img.id === imageId);
      if (removed?.preview) URL.revokeObjectURL(removed.preview);
      return prev.filter(img => img.id !== imageId);
    });
  };

  const handleSubmitCourtUpload = async () => {
    if (!uploadTargetCourt) {
      alert('কোর্ট তথ্য পাওয়া যায়নি');
      return;
    }
    if (courtUploadImages.length === 0) {
      alert('অন্তত একটি ছবি নির্বাচন করুন');
      return;
    }

    const formData = new FormData();
    courtUploadImages.forEach(img => formData.append('files', img.file, img.name));
    formData.append('lower_court_id', uploadTargetCourt.lower_court_id);
    formData.append('cause_date', moment(causeDate).format('YYYY-MM-DD'));

    if (uploadTargetDiary && uploadTargetDiary.diary_id) {
      formData.append('diary_id', uploadTargetDiary.diary_id);
    }

    try {
      setUploadingCourtImages(true);
      
      const endpoint = `${BASE_URL}/UploadCourtMultipleImages`;
      
      await axios.post(endpoint, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      alert('ছবি আপলোড সফল হয়েছে');
      closeCourtUploadModal();
      fetchCourtImagesGrouped();
    } catch (error) {
      console.log('Court Upload Error:', error?.response?.data || error.message);
      alert('আপলোড করতে সমস্যা হয়েছে: ' + (error?.response?.data?.message || error.message));
    } finally {
      setUploadingCourtImages(false);
    }
  };

  const fetchAllData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/GetAllThanaImages`);
      if (response.status === 200) {
        setAllData(response.data || []);
      }
    } catch (error) {
      console.log('Get All Data Error:', error);
    }
  };

  // ─── Image handling ─────────────────────────────────────────────────────────

  const mapFilesToImageState = files =>
    files
      .filter(file => file.type.startsWith('image/'))
      .map(file => ({
        file,
        preview: URL.createObjectURL(file),
        id: Date.now() + Math.random(),
        name: file.name,
        size: file.size,
        type: file.type,
      }));

  const handleImageSelect = event => {
    const newImages = mapFilesToImageState(Array.from(event.target.files));
    setSelectedImages(prev => [...prev, ...newImages]);
  };

  const handleImageDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    const imageFiles = files.filter(file => file.type.startsWith('image/'));
    if (imageFiles.length > 0) {
      const newImages = mapFilesToImageState(imageFiles);
      setSelectedImages(prev => [...prev, ...newImages]);
    }
  };

  const handleImageDragOver = (e) => {
    e.preventDefault();
  };

  const handleUpdateImageSelect = event => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      if (selectedUpdateImage?.preview) {
        URL.revokeObjectURL(selectedUpdateImage.preview);
      }
      setSelectedUpdateImage({
        file,
        preview: URL.createObjectURL(file),
        name: file.name,
        size: file.size,
      });
    }
  };

  const handleUpdateImageDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    const file = files.find(f => f.type.startsWith('image/'));
    if (file) {
      if (selectedUpdateImage?.preview) {
        URL.revokeObjectURL(selectedUpdateImage.preview);
      }
      setSelectedUpdateImage({
        file,
        preview: URL.createObjectURL(file),
        name: file.name,
        size: file.size,
      });
    }
  };

  const handleUpdateImageDragOver = (e) => {
    e.preventDefault();
  };

  const removeImage = imageId => {
    setSelectedImages(prev => {
      const removed = prev.find(img => img.id === imageId);
      if (removed?.preview) URL.revokeObjectURL(removed.preview);
      return prev.filter(img => img.id !== imageId);
    });
  };

  const formatFileSize = bytes => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1048576).toFixed(1)} MB`;
  };

  // ─── Search / Edit / Delete ──────────────────────────────────────────────

  const handleSearch = async () => {
    if (!searchDivisionId || !searchDistrictId) {
      alert('Please select both division and district to search');
      return;
    }
    try {
      const response = await axios.get(`${BASE_URL}/GetThanaImages`, {
        params: {
          diary_police_station_id: searchThanaId,
          status: 1,
          cause_date: searchCauseDate ? moment(searchCauseDate).format('YYYY-MM-DD') : undefined,
        },
      });
      if (response.status === 200) setAllData(response.data);
    } catch (error) {
      console.log('Get All Data Error:', error);
    }
  };

  const handleSubmitForm = async () => {
    if (selectedImages.length === 0) {
      alert('Please select at least one image');
      return;
    }
    if (!causeDate) {
      alert('Please select a date');
      return;
    }

    const formData = new FormData();
    selectedImages.forEach(image => formData.append('files', image.file, image.name));
    formData.append('cause_date', moment(causeDate).format('YYYY-MM-DD'));
    formData.append('diary_police_station_id', thanaId);

    try {
      setUploadingImages(true);
      await axios.post(`${BASE_URL}/UploadMultipleImages`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: progressEvent => {
          const progress = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
          setUploadProgress(prev => ({ ...prev, global: progress }));
        },
      });
      alert('Data added successfully');
      fetchAllData();
      setSelectedImages([]);
      setUploadProgress({});
    } catch (error) {
      console.log('Submit Error:', error?.response?.data || error.message);
      alert('Error adding data');
    } finally {
      setUploadingImages(false);
    }
  };

  const handleUpdateImage = item => {
    setEditingImage(item);
    setSelectedUpdateImage(null);
    setIsImageEditModalVisible(true);
  };

  const handleDeleteImage = item => {
    Alert.alert('Confirm Delete', 'Are you sure you want to delete this image?', [
      { text: 'Cancel', style: 'cancel' },
      {
        text: 'Delete',
        style: 'destructive',
        onPress: async () => {
          try {
            await axios.delete(`${BASE_URL}/DeleteThanaImage/${item.id}`);
            alert('Image deleted successfully');
            fetchAllData();
          } catch (error) {
            console.log('Delete Error:', error);
            alert('Error deleting image');
          }
        },
      },
    ]);
  };

  const handleSaveImageUpdate = async () => {
    if (!selectedUpdateImage && !editingImage) {
      alert('Please select a new image');
      return;
    }

    setUploadingUpdateImage(true);
    try {
      const formData = new FormData();
      if (selectedUpdateImage) {
        formData.append('file', selectedUpdateImage.file, selectedUpdateImage.name);
      }
      formData.append('id', editingImage.id);
      formData.append('cause_date', moment(searchCauseDate).format('YYYY-MM-DD'));
      formData.append('diary_police_station_id', searchThanaId);

      await axios.post(`${BASE_URL}/UpdateThanaImage`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      alert('Image updated successfully');
      setIsImageEditModalVisible(false);
      setEditingImage(null);
      setSelectedUpdateImage(null);
      handleSearch();
    } catch (error) {
      console.log('Update Error:', error);
      alert('Error updating image');
    } finally {
      setUploadingUpdateImage(false);
    }
  };

  const handleEditData = async item => {
    setIsEditModalVisible(true);
    setEditId(item.id);
    setEditDivisionId(item.geo_division_id?.toString());
    await fetchEditDistrictsByDivision(item.geo_division_id?.toString());
    setEditDistrictId(item.geo_district_id?.toString());
    await fetchEditLowerCourtsByDistrict(item.geo_district_id?.toString());
    setEditLowerCourtId(item.gr_branch_id?.toString());
    setEditLowerCourtName(item.name_bng?.toString());
  };

  const handleUpdateData = async () => {
    if (!editLowerCourtName || !editDivisionId || !editDistrictId) {
      alert('Please fill all fields');
      return;
    }

    const payload = {
      id: editId,
      geo_division_id: editDivisionId,
      geo_district_id: editDistrictId,
      gr_branch_id: editLowerCourtId,
      name_bng: editLowerCourtName,
      status: 1,
    };
    const formBody = Object.entries(payload)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');

    try {
      await axios.post(`${BASE_URL}/PoliceStationUpdate`, formBody);
      alert('Data updated successfully');
      handleCloseEditModal();
      fetchAllData();
    } catch (error) {
      console.log('Update Error:', error);
      alert('Error updating data');
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setEditId(null);
    setEditDivisionId('');
    setEditDistrictId('');
    setEditLowerCourtId('');
    setEditLowerCourtName('');
    setEditDistricts([]);
    setEditLowerCourts([]);
  };

  // ─── Image Preview Renderer ─────────────────────────────────────────────────

  const renderImagePreview = () => {
    if (selectedImages.length === 0) return null;

    return (
      <View style={styles.imagePreviewContainer}>
        <View style={styles.previewSummaryRow}>
          <Text style={styles.imagePreviewTitle}>
            {selectedImages.length} image{selectedImages.length > 1 ? 's' : ''} selected
          </Text>
          <TouchableOpacity onPress={() => setSelectedImages([])} disabled={uploadingImages}>
            <Text style={styles.clearAllText}>Clear all</Text>
          </TouchableOpacity>
        </View>

        <View style={styles.previewCardsContainer}>
          {selectedImages.map(image => (
            <View key={image.id} style={styles.previewCard}>
              <Image source={{ uri: image.preview }} style={styles.imagePreview} />
              <TouchableOpacity
                style={styles.removeImageButton}
                onPress={() => removeImage(image.id)}
                disabled={uploadingImages}
              >
                <Text style={styles.removeImageText}>×</Text>
              </TouchableOpacity>
              {uploadProgress[image.id] > 0 && uploadingImages && (
                <View style={styles.uploadProgressOverlay}>
                  <Text style={styles.uploadProgressText}>{uploadProgress[image.id]}%</Text>
                </View>
              )}
              <View style={styles.previewFooter}>
                <Text style={styles.imageName} numberOfLines={1}>
                  {image.name}
                </Text>
                <Text style={styles.imageSize}>{formatFileSize(image.size)}</Text>
                {uploadProgress[image.id] > 0 && uploadingImages && (
                  <View style={styles.uploadBarWrap}>
                    <View style={[styles.uploadBar, { width: `${uploadProgress[image.id]}%` }]} />
                  </View>
                )}
              </View>
            </View>
          ))}
        </View>
      </View>
    );
  };

  // ─── Image Grid for Diary ──────────────────────────────────────────────────

  const renderImageGrid = (images, diaryId, title = '') => {
    if (!images || images.length === 0) return null;

    return (
      <View style={styles.imageGridContainer}>
        {images.map((img, index) => (
          <TouchableOpacity
            key={img.id}
            style={styles.imageGridItem}
            onPress={() => openImageViewer(images, index, title)}
            activeOpacity={0.8}
          >
            <Image
              source={{ uri: 'https://api.bdjudgecourt.com' + img.file_path }}
              style={styles.imageGridThumb}
              resizeMode="cover"
            />
            <View style={styles.imageGridOverlay}>
              <Text style={styles.imageGridOverlayText}>🔍</Text>
            </View>
            <TouchableOpacity
              style={styles.imageGridEditBtn}
              onPress={(e) => {
                e.stopPropagation();
                handleUpdateImage(img);
              }}
            >
              <Text style={styles.imageGridEditBtnText}>এডিট</Text>
            </TouchableOpacity>
          </TouchableOpacity>
        ))}
      </View>
    );
  };

  // ─── Data List Renderer ────────────────────────────────────────────────────

  const renderDataList = () => {
    if (!allData || allData.length === 0) {
      return (
        <View style={styles.emptyListContainer}>
          <Text style={styles.emptyListText}>কোনো তথ্য পাওয়া যায়নি</Text>
        </View>
      );
    }

    return (
      <View style={styles.listSection}>
        <Text style={styles.listSectionTitle}>থানা / অঞ্চলের তালিকা</Text>
        <View style={styles.listGrid}>
          {allData.map((item, index) => (
            <View key={item.id ?? index} style={styles.listCard}>
              <Image
                source={{
                  uri: item.file_path
                    ? 'https://api.bdjudgecourt.com' + item.file_path
                    : 'https://bdjudgecourt.com/assets/no-image.png',
                }}
                style={styles.listThumbnail}
                resizeMode="cover"
              />

              <View style={styles.listCardBody}>
                <Text style={styles.listCardTitle} numberOfLines={1}>
                  {item.name_bng || item.office_name_bng || 'নাম নেই'}
                </Text>
                {!!item.cause_date && (
                  <Text style={styles.listCardSubtitle}>
                    {moment(item.cause_date).format('DD-MM-YYYY')}
                  </Text>
                )}
              </View>

              <View style={styles.listCardActions}>
                <TouchableOpacity
                  style={[styles.listActionButton, styles.uploadActionButton]}
                  onPress={() => handleUpdateImage(item)}
                >
                  <Text style={styles.listActionButtonText}>ছবি আপলোড</Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={[styles.listActionButton, styles.editActionButton]}
                  onPress={() => handleEditData(item)}
                >
                  <Text style={styles.listActionButtonText}>এডিট</Text>
                </TouchableOpacity>
              </View>
            </View>
          ))}
        </View>
      </View>
    );
  };

  // ─── Court Images Tree Renderer ────────────────────────────────────────────

  // সাধারণ Court এর রেন্ডারার
  const renderRegularCourtTreeColumn = (list, hasImages) => (
    <View style={styles.treeColumn}>
      <Text style={[styles.treeColumnTitle, hasImages ? styles.treeColumnTitleGreen : styles.treeColumnTitleRed]}>
        {hasImages ? `ছবি আছে (${list.length})` : `ছবি নাই (${list.length})`}
      </Text>

      {list.length === 0 && <Text style={styles.treeEmptyText}>কোনো তথ্য নাই</Text>}

      {list.map(court => {
        const isExpanded = !!expandedCourtIds[court.lower_court_id];
        const childCount = court.images ? court.images.length : 0;

        return (
          <View key={court.lower_court_id} style={styles.treeParentCard}>
            <TouchableOpacity
              style={styles.treeParentRow}
              onPress={() => hasImages && toggleCourtExpand(court.lower_court_id)}
              activeOpacity={hasImages ? 0.6 : 1}
            >
              <View style={{ flex: 1 }}>
                <Text style={styles.treeParentTitle} numberOfLines={1}>
                  {court.office_name_bng || court.office_name_eng}
                </Text>
                <Text style={styles.treeParentSubtitle}>
                  {hasImages ? `${childCount} টি ছবি` : 'কোনো ছবি আপলোড হয়নি'}
                </Text>
              </View>

              {hasImages && <Text style={styles.treeExpandIcon}>{isExpanded ? '▲' : '▼'}</Text>}

              <TouchableOpacity
                style={styles.treeUploadButton}
                onPress={() => openCourtUploadModal(court)}
              >
                <Text style={styles.treeUploadButtonText}>আপলোড</Text>
              </TouchableOpacity>
            </TouchableOpacity>

            {hasImages && isExpanded && (
              <View style={styles.treeChildrenWrap}>
                {court.images && court.images.length > 0 && 
                  renderImageGrid(court.images, `court_${court.lower_court_id}`, court.office_name_bng)
                }
              </View>
            )}
          </View>
        );
      })}
    </View>
  );

  // Chief Court এর রেন্ডারার
  const renderChiefCourtTreeColumn = (list, hasImages) => (
    <View style={styles.treeColumn}>
      <Text style={[styles.treeColumnTitle, hasImages ? styles.treeColumnTitleGreen : styles.treeColumnTitleRed]}>
        {hasImages ? `ছবি আছে (${list.length})` : `ছবি নাই (${list.length})`}
      </Text>

      {list.length === 0 && <Text style={styles.treeEmptyText}>কোনো তথ্য নাই</Text>}

      {list.map(court => {
        const isExpanded = !!expandedCourtIds[court.lower_court_id];
        const diariesWithImages = court.diariesWithImages || [];
        const diariesWithoutImages = court.diariesWithoutImages || [];
        const totalDiaries = diariesWithImages.length + diariesWithoutImages.length;

        return (
          <View key={court.lower_court_id} style={styles.treeParentCard}>
            <TouchableOpacity
              style={styles.treeParentRow}
              onPress={() => toggleCourtExpand(court.lower_court_id)}
              activeOpacity={0.6}
            >
              <View style={{ flex: 1 }}>
                <Text style={styles.treeParentTitle} numberOfLines={1}>
                  {court.office_name_bng || court.office_name_eng}
                </Text>
                <Text style={styles.treeParentSubtitle}>
                  মোট {totalDiaries} টি ডায়রি
                  {hasImages ? ` (${diariesWithImages.length} টিতে ছবি আছে)` : ''}
                </Text>
              </View>

              <Text style={styles.treeExpandIcon}>{isExpanded ? '▲' : '▼'}</Text>
            </TouchableOpacity>

            {isExpanded && (
              <View style={styles.treeChildrenWrap}>
                {diariesWithoutImages.map(diary => (
                  <View key={diary.diary_id} style={[styles.treeDiaryCard, styles.treeDiaryCardNoImage]}>
                    <View style={styles.treeDiaryRow}>
                      <View style={{ flex: 1 }}>
                        <View style={styles.treeDiaryHeader}>
                          <Text style={styles.treeParentTitle} numberOfLines={1}>
                            {diary.name_bng || diary.name_eng}
                          </Text>
                          <Text style={[styles.treeDiaryBadge, styles.treeDiaryBadgeNoImage]}>
                            ❌ ছবি নাই
                          </Text>
                        </View>
                      </View>
                      <TouchableOpacity
                        style={styles.treeUploadButton}
                        onPress={() => openCourtUploadModal(court, diary)}
                      >
                        <Text style={styles.treeUploadButtonText}>আপলোড</Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                ))}

                {diariesWithImages.map(diary => {
                  const isDiaryExpanded = !!expandedDiaryIds[diary.diary_id];
                  return (
                    <View key={diary.diary_id} style={[styles.treeDiaryCard, styles.treeDiaryCardHasImage]}>
                      <TouchableOpacity
                        style={styles.treeDiaryRow}
                        onPress={() => toggleDiaryExpand(diary.diary_id)}
                        activeOpacity={0.6}
                      >
                        <View style={{ flex: 1 }}>
                          <View style={styles.treeDiaryHeader}>
                            <Text style={styles.treeParentTitle} numberOfLines={1}>
                              {diary.name_bng || diary.name_eng}
                            </Text>
                            <View style={styles.treeDiaryStatusContainer}>
                              <Text style={[styles.treeDiaryBadge, styles.treeDiaryBadgeHasImage]}>
                                ✅ {diary.images.length}টি
                              </Text>
                              <Text style={styles.treeDiaryUploadText}>(আপলোড করুন)</Text>
                            </View>
                          </View>
                        </View>
                        <View style={styles.treeDiaryActions}>
                          <Text style={styles.treeExpandIcon}>
                            {isDiaryExpanded ? '▲' : '▼'}
                          </Text>
                          <TouchableOpacity
                            style={styles.treeUploadButton}
                            onPress={() => openCourtUploadModal(court, diary)}
                          >
                            <Text style={styles.treeUploadButtonText}>+</Text>
                          </TouchableOpacity>
                        </View>
                      </TouchableOpacity>

                      {isDiaryExpanded && (
                        <View style={styles.treeChildImagesWrap}>
                          {diary.images && diary.images.length > 0 && 
                            renderImageGrid(diary.images, diary.diary_id, diary.name_bng || diary.name_eng)
                          }
                        </View>
                      )}
                    </View>
                  );
                })}
              </View>
            )}
          </View>
        );
      })}
    </View>
  );

  const renderCourtImagesTree = () => {
    const isChiefCourt = CHIEF_COURT_IDS.includes(courtTypeId);

    return (
      <View style={styles.treeSection}>
        <Text style={styles.listSectionTitle}>
          {isChiefCourt ? 'থানা অনুযায়ী কার্যতালিকার ছবি' : 'কোর্ট অনুযায়ী কার্যতালিকার ছবি'}
        </Text>

        {loadingCourtImages && <ActivityIndicator size="large" color="#378ADD" style={{ marginTop: 20 }} />}

        {!loadingCourtImages && (
          <View style={styles.treeColumnsRow}>
            {isChiefCourt ? (
              <>
                {renderChiefCourtTreeColumn(courtsWithoutImages, false)}
                {renderChiefCourtTreeColumn(courtsWithImages, true)}
              </>
            ) : (
              <>
                {renderRegularCourtTreeColumn(courtsWithoutImages, false)}
                {renderRegularCourtTreeColumn(courtsWithImages, true)}
              </>
            )}
          </View>
        )}
      </View>
    );
  };

  // ─── Render ─────────────────────────────────────────────────────────────────

  return (
    <ScrollView>
      <View style={isWideWeb ? globalStyles.mainContainerAdmin : globalStyles.mainContainerMobile}>
        <LeftBar>
          {adminMenus.map((item, index) => (
            <LeftBarItemAdmin
              key={item.screen || index}
              activeScreen={route.name}
              name={item.name}
              stack={item.stack}
              screen={item.screen}
            />
          ))}
        </LeftBar>

        <View style={isWideWeb ? globalStyles.bodyContainer : globalStyles.bodyContainerMobile}>
          <View style={styles.stickyTopSection}>
            <View style={styles.formSectionContainer}>
              <Formik
                initialValues={{ divisionName: '', districtName: '', grBranchId: '', nameBng: '' }}
                validationSchema={basicInfoSchema}
                onSubmit={handleSubmitForm}
              >
                {({ handleChange, handleSubmit, setFieldValue, setFieldTouched, touched, errors }) => (
                  <View style={styles.formWrapper}>
                    <View style={styles.formGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={divisionId || ''}
                          style={styles.picker}
                          mode="dropdown"
                          onValueChange={itemValue => {
                            setDivisionId(itemValue);
                            fetchDistrictsByDivision(itemValue);
                            handleChange('divisionName')(itemValue);
                            setFieldTouched('divisionName', true);
                          }}
                        >
                          <Picker.Item label="বিভাগ নির্বাচন করুনঃ–" value="" color="red" />
                          {divisions.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.division_name_bng?.toString()}
                              value={item.geo_division_id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.divisionName && errors.divisionName && (
                        <ErrorText>{errors.divisionName}</ErrorText>
                      )}
                    </View>

                    <View style={styles.formGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={districtId || ''}
                          style={styles.picker}
                          mode="dropdown"
                          onValueChange={itemValue => {
                            setDistrictId(itemValue);
                            setFieldValue('districtName', itemValue, true);
                            setFieldTouched('districtName', true, false);
                            setCourtTypes(
                              METRO_DISTRICT_IDS.includes(Number(itemValue))
                                ? COURT_TYPE_METRO
                                : COURT_TYPE_DISTRICT,
                            );
                          }}
                        >
                          <Picker.Item label="জেলা নির্বাচন করুনঃ" value="" color="red" />
                          {districts.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.district_name_bng?.toString()}
                              value={item.geo_district_id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.districtName && errors.districtName && (
                        <ErrorText>{errors.districtName}</ErrorText>
                      )}
                    </View>

                    <View style={styles.formGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={courtTypeId || ''}
                          style={styles.picker2}
                          mode="dropdown"
                          onValueChange={itemValue => {
                            setCourtTypeId(itemValue);
                            setFieldValue('grBranchId', itemValue, true);
                            setFieldTouched('grBranchId', true, false);
                          }}
                        >
                          <Picker.Item label="আদালতের ধরণ নির্বাচন করুনঃ–" value="" color="red" />
                          {courtTypes.map((item, idx) => (
                            <Picker.Item
                              key={idx}
                              label={`${item.name}`}
                              value={item.id.toString()}
                              color="#333"
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.grBranchId && errors.grBranchId && (
                        <ErrorText>{errors.grBranchId}</ErrorText>
                      )}
                    </View>

                    <View style={styles.formGroup}>
                      <View style={styles.pickerWrapper}>
                        <TouchableOpacity onPress={showDatePicker} style={styles.sectionStyle}>
                          <TextInput
                            style={styles.inputs1}
                            value={causeDate ? moment(causeDate).format('DD-MM-YYYY') : ''}
                            placeholder="DD-MM-YYYY"
                            placeholderTextColor="#999"
                            editable={false}
                            pointerEvents="none"
                          />
                          <Image
                            source={{ uri: 'https://bdjudgecourt.com/assets/calendar.png' }}
                            style={styles.imageStyle}
                          />
                        </TouchableOpacity>
                      </View>
                      {!causeDate && <ErrorText>Please select a date</ErrorText>}
                    </View>
                    <TouchableOpacity
                      style={styles.treeSearchButton}
                      onPress={fetchCourtImagesGrouped}
                      disabled={loadingCourtImages}
                    >
                      <Text style={styles.submitButtonText}>{loadingCourtImages ? 'খুঁজছে…' : 'খুঁজুন'}</Text>
                    </TouchableOpacity>
                  </View>
                )}
              </Formik>
            </View>
          </View>

          {renderCourtImagesTree()}

          <DatePickerModal
            locale={locale}
            mode="single"
            visible={isDatePickerVisible}
            onDismiss={hideDatePicker}
            date={causeDate || new Date()}
            onConfirm={handleDateConfirm}
            onChange={handleDateConfirm}
            validRange={{ startDate: pastDate, endDate: futureDate }}
          />

          <DatePickerModal
            locale={locale}
            mode="single"
            visible={isSearchDatePickerVisible}
            onDismiss={hideSearchDatePicker}
            date={searchCauseDate || new Date()}
            onConfirm={handleSearchDateConfirm}
            onChange={handleSearchDateConfirm}
            validRange={{ startDate: pastDate, endDate: futureDate }}
          />
        </View>
      </View>

      {/* Image Viewer Modal with Zoom */}
      <Modal
        animationType="fade"
        transparent
        visible={isImageViewerVisible}
        onRequestClose={closeImageViewer}
      >
        <View style={styles.imageViewerOverlay}>
          <View style={styles.imageViewerHeader}>
            <Text style={styles.imageViewerTitle} numberOfLines={1}>
              {viewerTitle}
            </Text>
            <TouchableOpacity onPress={closeImageViewer} style={styles.imageViewerClose}>
              <Text style={styles.imageViewerCloseText}>✕</Text>
            </TouchableOpacity>
          </View>

          <View style={styles.imageViewerBody}>
            {viewerImages.length > 0 && (
              <div
                style={styles.imageViewerImageContainer}
                onWheel={handleWheel}
              >
                <img
                  src={'https://api.bdjudgecourt.com' + viewerImages[viewerCurrentIndex]?.file_path}
                  alt={viewerImages[viewerCurrentIndex]?.name_bng || 'Image'}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    transform: `scale(${zoomLevel}) translate(${zoomPan.x}px, ${zoomPan.y}px)`,
                    transition: 'transform 0.1s ease-out',
                    cursor: zoomLevel > 1 ? 'grab' : 'default',
                  }}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
                />
              </div>
            )}

            {viewerImages.length > 1 && (
              <>
                <TouchableOpacity
                  style={[styles.imageViewerNav, styles.imageViewerNavLeft]}
                  onPress={goToViewerPrevious}
                >
                  <Text style={styles.imageViewerNavText}>◀</Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={[styles.imageViewerNav, styles.imageViewerNavRight]}
                  onPress={goToViewerNext}
                >
                  <Text style={styles.imageViewerNavText}>▶</Text>
                </TouchableOpacity>
              </>
            )}
          </View>

          <View style={styles.imageViewerFooter}>
            <View style={styles.imageViewerControls}>
              <TouchableOpacity
                style={[styles.imageViewerControlBtn, styles.imageViewerZoomBtn]}
                onPress={handleZoomOut}
              >
                <Text style={styles.imageViewerControlText}>−</Text>
              </TouchableOpacity>
              <Text style={styles.imageViewerZoomText}>{Math.round(zoomLevel * 100)}%</Text>
              <TouchableOpacity
                style={[styles.imageViewerControlBtn, styles.imageViewerZoomBtn]}
                onPress={handleZoomIn}
              >
                <Text style={styles.imageViewerControlText}>+</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.imageViewerControlBtn, styles.imageViewerResetBtn]}
                onPress={handleZoomReset}
              >
                <Text style={[styles.imageViewerControlText, { fontSize: 12 }]}>⟲</Text>
              </TouchableOpacity>
            </View>
            <View style={styles.imageViewerCounter}>
              <Text style={styles.imageViewerCounterText}>
                {viewerCurrentIndex + 1} / {viewerImages.length}
              </Text>
            </View>
            <TouchableOpacity
              style={styles.imageViewerEditBtn}
              onPress={() => {
                closeImageViewer();
                setTimeout(() => {
                  handleUpdateImage(viewerImages[viewerCurrentIndex]);
                }, 300);
              }}
            >
              <Text style={styles.imageViewerEditBtnText}>এডিট</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>

      {/* Image Edit Modal */}
      <Modal
        animationType="slide"
        transparent
        visible={isImageEditModalVisible}
        onRequestClose={() => setIsImageEditModalVisible(false)}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContainer}>
            <Text style={styles.modalTitle}>Update Image</Text>

            {editingImage && !selectedUpdateImage && (
              <>
                <Text style={styles.modalLabel}>Current Image</Text>
                <Image
                  source={{ uri: 'https://api.bdjudgecourt.com' + editingImage.file_path }}
                  style={styles.editImagePreview}
                  resizeMode="cover"
                />
              </>
            )}

            {selectedUpdateImage && (
              <>
                <Text style={styles.modalLabel}>New Image</Text>
                <Image source={{ uri: selectedUpdateImage.preview }} style={styles.editImagePreview} resizeMode="cover" />
                <Text style={styles.imageName}>{selectedUpdateImage.name}</Text>
                <Text style={styles.imageSize}>{formatFileSize(selectedUpdateImage.size)}</Text>
              </>
            )}

            <div
              style={styles.editDropzone}
              onClick={() => document.getElementById('updateImageInput').click()}
              onDrop={handleUpdateImageDrop}
              onDragOver={handleUpdateImageDragOver}
            >
              <input
                type="file"
                accept="image/*"
                id="updateImageInput"
                onChange={handleUpdateImageSelect}
                style={{ display: 'none' }}
                disabled={uploadingUpdateImage}
              />
              <Text style={styles.dropzoneIconText}>📷</Text>
              <Text style={styles.dropzoneMainText}>Click to select or Drag & Drop new image</Text>
            </div>

            <View style={styles.modalButtonContainer}>
              <TouchableOpacity
                style={[styles.modalButton, styles.cancelButton]}
                onPress={() => {
                  setIsImageEditModalVisible(false);
                  setEditingImage(null);
                  if (selectedUpdateImage?.preview) {
                    URL.revokeObjectURL(selectedUpdateImage.preview);
                  }
                  setSelectedUpdateImage(null);
                }}
              >
                <Text style={styles.cancelButtonText}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.modalButton, styles.updateButton]}
                onPress={handleSaveImageUpdate}
                disabled={uploadingUpdateImage}
              >
                <Text style={styles.updateButtonText}>
                  {uploadingUpdateImage ? 'Updating...' : 'Update'}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Edit Modal for Police Station */}
      <Modal animationType="slide" transparent visible={isEditModalVisible} onRequestClose={handleCloseEditModal}>
        <View style={styles.modalOverlay}>
          <View style={styles.modalContainer}>
            <Text style={styles.modalTitle}>Edit Data</Text>

            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Division</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editDivisionId || ''}
                  style={styles.modalPicker}
                  mode="dropdown"
                  onValueChange={async itemValue => {
                    setEditDivisionId(itemValue);
                    await fetchEditDistrictsByDivision(itemValue);
                    setEditDistrictId('');
                  }}
                >
                  <Picker.Item label="বিভাগ নির্বাচন করুনঃ–" value="" color="red" />
                  {divisions.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.division_name_bng?.toString()}
                      value={item.geo_division_id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>District</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editDistrictId || ''}
                  style={styles.modalPicker}
                  mode="dropdown"
                  onValueChange={async itemValue => {
                    setEditDistrictId(itemValue);
                    await fetchEditLowerCourtsByDistrict(itemValue);
                  }}
                >
                  <Picker.Item label="জেলা নির্বাচন করুনঃ–" value="" color="red" />
                  {editDistricts.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.district_name_bng?.toString()}
                      value={item.geo_district_id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Branch Name</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editLowerCourtId || ''}
                  style={styles.modalPicker}
                  mode="dropdown"
                  onValueChange={itemValue => {
                    setEditLowerCourtId(itemValue);
                    const selected = editLowerCourts.find(item => item.id?.toString() === itemValue);
                    setEditLowerCourtName(selected?.name_bng || '');
                  }}
                >
                  <Picker.Item label="শাখার নাম নির্বাচন করুনঃ–" value="" color="red" />
                  {editLowerCourts.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.name_bng?.toString()}
                      value={item.id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Thana / Area Name</Text>
              <View style={styles.modalInputWrapper}>
                <TextInput
                  placeholder="থানা / অঞ্চল লিখুন"
                  placeholderTextColor="#999"
                  style={styles.modalTextInput}
                  value={editLowerCourtName}
                  onChangeText={setEditLowerCourtName}
                  editable
                />
              </View>
            </View>

            <View style={styles.modalButtonContainer}>
              <TouchableOpacity style={[styles.modalButton, styles.cancelButton]} onPress={handleCloseEditModal}>
                <Text style={styles.cancelButtonText}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity style={[styles.modalButton, styles.updateButton]} onPress={handleUpdateData}>
                <Text style={styles.updateButtonText}>Update</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Court Image Upload Modal */}
      <Modal
        animationType="slide"
        transparent
        visible={isCourtUploadModalVisible}
        onRequestClose={closeCourtUploadModal}
      >
        <View style={styles.modalOverlay}>
          <View style={[styles.modalContainer, styles.modalContainerScrollable]}>
            <Text style={styles.modalTitle}>ছবি আপলোড করুন</Text>
            {uploadTargetCourt && (
              <Text style={styles.modalLabel}>
                {uploadTargetCourt.office_name_bng || uploadTargetCourt.office_name_eng}
                {'  ·  '}
                {moment(causeDate).format('DD-MM-YYYY')}
                {uploadTargetDiary && (
                  <Text style={{ fontSize: 12, color: '#666' }}>
                    {'\n'}থানা: {uploadTargetDiary.name_bng || uploadTargetDiary.name_eng}
                  </Text>
                )}
              </Text>
            )}

            <div
              style={styles.editDropzone}
              onClick={() => document.getElementById('courtUploadInput').click()}
              onDrop={handleCourtUploadDrop}
              onDragOver={handleCourtUploadDragOver}
            >
              <input
                type="file"
                accept="image/*"
                id="courtUploadInput"
                multiple
                onChange={handleCourtUploadImageSelect}
                style={{ display: 'none' }}
                disabled={uploadingCourtImages}
              />
              <Text style={styles.dropzoneIconText}>📷</Text>
              <Text style={styles.dropzoneMainText}>Click to select or Drag & Drop images</Text>
              <Text style={styles.dropzoneSubText}>Multiple images supported</Text>
            </div>

            {courtUploadImages.length > 0 && (
              <View style={styles.previewCardsContainerScrollable}>
                {courtUploadImages.map(image => (
                  <View key={image.id} style={styles.previewCard}>
                    <Image source={{ uri: image.preview }} style={styles.imagePreview} />
                    <TouchableOpacity
                      style={styles.removeImageButton}
                      onPress={() => removeCourtUploadImage(image.id)}
                      disabled={uploadingCourtImages}
                    >
                      <Text style={styles.removeImageText}>×</Text>
                    </TouchableOpacity>
                    <View style={styles.previewFooter}>
                      <Text style={styles.imageName} numberOfLines={1}>
                        {image.name}
                      </Text>
                      <Text style={styles.imageSize}>{formatFileSize(image.size)}</Text>
                    </View>
                  </View>
                ))}
              </View>
            )}

            <View style={styles.modalButtonContainer}>
              <TouchableOpacity
                style={[styles.modalButton, styles.cancelButton]}
                onPress={closeCourtUploadModal}
                disabled={uploadingCourtImages}
              >
                <Text style={styles.cancelButtonText}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.modalButton, styles.updateButton]}
                onPress={handleSubmitCourtUpload}
                disabled={uploadingCourtImages}
              >
                <Text style={styles.updateButtonText}>
                  {uploadingCourtImages ? 'Uploading…' : 'Upload'}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </ScrollView>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  // ... (previous styles remain same)

  // Image Grid Styles
  imageGridContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    padding: 4,
  },
  imageGridItem: {
    width: 80,
    height: 80,
    borderRadius: 6,
    overflow: 'hidden',
    borderWidth: 0.5,
    borderColor: '#e2e8f0',
    position: 'relative',
    backgroundColor: '#f1f5f9',
  },
  imageGridThumb: {
    width: '100%',
    height: '100%',
  },
  imageGridOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.2)',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: 0,
  },
  imageGridOverlayText: {
    color: '#fff',
    fontSize: 20,
  },
  imageGridEditBtn: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    alignItems: 'center',
    paddingVertical: 3,
  },
  imageGridEditBtnText: {
    color: '#fff',
    fontSize: 9,
    fontWeight: '600',
  },

  // Image Viewer Modal Styles
  imageViewerOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.92)',
    justifyContent: 'space-between',
  },
  imageViewerHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingTop: 20,
    paddingBottom: 10,
    backgroundColor: 'rgba(0,0,0,0.3)',
  },
  imageViewerTitle: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
    flex: 1,
    marginRight: 16,
  },
  imageViewerClose: {
    padding: 8,
  },
  imageViewerCloseText: {
    color: '#fff',
    fontSize: 24,
    fontWeight: 'bold',
  },
  imageViewerBody: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  imageViewerImageContainer: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  imageViewerNav: {
    position: 'absolute',
    top: '50%',
    transform: [{ translateY: -30 }],
    backgroundColor: 'rgba(255,255,255,0.2)',
    borderRadius: 30,
    width: 50,
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 20,
  },
  imageViewerNavLeft: {
    left: 16,
  },
  imageViewerNavRight: {
    right: 16,
  },
  imageViewerNavText: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 'bold',
  },
  imageViewerFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 16,
    backgroundColor: 'rgba(0,0,0,0.3)',
  },
  imageViewerControls: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  imageViewerControlBtn: {
    width: 36,
    height: 36,
    borderRadius: 18,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255,255,255,0.15)',
  },
  imageViewerZoomBtn: {
    backgroundColor: 'rgba(255,255,255,0.15)',
  },
  imageViewerResetBtn: {
    backgroundColor: 'rgba(255,255,255,0.15)',
  },
  imageViewerControlText: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold',
  },
  imageViewerZoomText: {
    color: '#fff',
    fontSize: 13,
    fontWeight: '500',
    minWidth: 45,
    textAlign: 'center',
  },
  imageViewerCounter: {
    paddingHorizontal: 12,
  },
  imageViewerCounterText: {
    color: 'rgba(255,255,255,0.8)',
    fontSize: 13,
    fontWeight: '500',
  },
  imageViewerEditBtn: {
    backgroundColor: '#2E9E6C',
    paddingVertical: 8,
    paddingHorizontal: 20,
    borderRadius: 6,
  },
  imageViewerEditBtnText: {
    color: '#fff',
    fontSize: 13,
    fontWeight: '600',
  },
 headerContainer: {
    marginTop: 0,
    marginHorizontal: 10,
  },
  stickyTopSection: {
    position: Platform.OS === 'web' ? 'sticky' : 'relative',
    top: 0,
    zIndex: 20,
    paddingBottom: 0,
  },
  formSectionContainer: {
    width: '100%',
  },
  headerTexth: {
    fontSize: 20,
    fontWeight: 'bold',
    color: Colors2.top5,
    textAlign: 'left',
    marginLeft: 10,
  },
  formWrapper: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 12,
    paddingHorizontal: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  formGroup: {
    marginBottom: 14,
    marginHorizontal: 8,
  },
  pickerWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 4,
    backgroundColor: '#fff',
    overflow: 'hidden',
    height: 30,
  },
  sectionStyle: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    backgroundColor: '#fff',
    borderColor: '#000',
    borderRadius: 4,
    height: 30,
    position: 'relative',
  },
  imageStyle: {
    position: 'absolute',
    width: 20,
    height: 20,
    right: 8,
  },
  inputs1: {
    borderRadius: 2,
    fontSize: 13,
    width: 125,
    backgroundColor: '#fff',
    paddingLeft: 5,
  },
  picker: {
    height: isWideWeb ? 42 : 50,
    width: '100%',
    color: '#333',
  },
  picker2: {
    height: isWideWeb ? 42 : 50,
    width: '100%',
    color: '#333',
  },
  submitButton: {
    backgroundColor: '#007bff',
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 4,
    alignSelf: 'flex-start',
    marginLeft: '2%',
  },
  submitButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },

  imageUploadSection: {
    width: '100%',
    marginTop: 14,
    marginBottom: 10,
    paddingHorizontal: 8,
  },
  imageUploadLabel: {
    fontSize: 11,
    fontWeight: '600',
    color: '#64748b',
    letterSpacing: 1,
    textTransform: 'uppercase',
    marginBottom: 10,
  },
  dropzoneWeb: {
    border: '1.5px dashed #94a3b8',
    borderRadius: 12,
    padding: '28px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 6,
    cursor: 'pointer',
    backgroundColor: '#f8fafc',
  },
  dropzoneIconText: {
    fontSize: 28,
    color: '#378ADD',
    marginBottom: 4,
    textAlign: 'center',
  },
  dropzoneMainText: {
    fontSize: 14,
    color: '#64748b',
    textAlign: 'center',
  },
  dropzoneBrowse: {
    color: '#185FA5',
    fontWeight: '600',
  },
  dropzoneSubText: {
    fontSize: 12,
    color: '#94a3b8',
    marginTop: 2,
    textAlign: 'center',
    paddingBottom: 16,
  },
  imagePreviewContainer: {
    marginTop: 14,
  },
  previewSummaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  imagePreviewTitle: {
    fontSize: 12,
    color: '#64748b',
    fontWeight: '500',
  },
  clearAllText: {
    fontSize: 12,
    color: '#A32D2D',
    fontWeight: '500',
  },
  previewCardsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  previewCard: {
    width: '31.33%',
    marginBottom: 10,
    borderWidth: 0.5,
    borderColor: '#e2e8f0',
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: '#fff',
  },
  imagePreview: {
    width: '100%',
    height: 160,
  },
  removeImageButton: {
    position: 'absolute',
    top: 4,
    right: 4,
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: 'rgba(226,75,74,0.9)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  removeImageText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 18,
  },
  uploadProgressOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 160,
    backgroundColor: 'rgba(0,0,0,0.55)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  uploadProgressText: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 'bold',
  },
  previewFooter: {
    padding: 8,
  },
  imageName: {
    fontSize: 11,
    color: '#64748b',
    marginBottom: 2,
  },
  imageSize: {
    fontSize: 10,
    color: '#94a3b8',
  },
  uploadBarWrap: {
    height: 3,
    backgroundColor: '#e2e8f0',
    borderRadius: 2,
    marginTop: 4,
    overflow: 'hidden',
  },
  uploadBar: {
    height: 3,
    backgroundColor: '#378ADD',
    borderRadius: 2,
  },
  uploadingIndicator: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: 10,
    padding: 10,
    backgroundColor: '#E6F1FB',
    borderRadius: 8,
    borderWidth: 0.5,
    borderColor: '#B5D4F4',
  },
  uploadingText: {
    marginLeft: 8,
    fontSize: 13,
    color: '#185FA5',
    fontWeight: '500',
  },

  editImagePreview: {
    width: '100%',
    height: 200,
    borderRadius: 8,
    marginBottom: 10,
  },
  editDropzone: {
    border: '1.5px dashed #94a3b8',
    borderRadius: 12,
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    backgroundColor: '#f8fafc',
    marginTop: 10,
  },

  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 20,
    width: '90%',
    maxWidth: 500,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    color: '#333',
  },
  modalFormGroup: {
    marginBottom: 15,
  },
  modalLabel: {
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 5,
    color: '#333',
  },
  modalPickerWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 8,
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  modalPicker: {
    height: 50,
    width: '100%',
    color: '#333',
  },
  modalInputWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 8,
    backgroundColor: '#fff',
  },
  modalTextInput: {
    height: 50,
    paddingHorizontal: 12,
    fontSize: 16,
    color: '#333',
  },
  modalButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    gap: 10,
  },
  modalButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  cancelButton: {
    backgroundColor: '#f5f5f5',
    borderWidth: 1,
    borderColor: '#ddd',
  },
  cancelButtonText: {
    color: '#666',
    fontSize: 16,
    fontWeight: '600',
  },
  updateButton: {
    backgroundColor: '#007bff',
  },
  updateButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },

  listSection: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 16,
    marginBottom: 24,
  },
  listSectionTitle: {
    fontSize: 15,
    fontWeight: '700',
    color: '#333',
    marginBottom: 12,
    paddingHorizontal: 4,
  },
  listGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  listCard: {
    width: isWideWeb ? '23.5%' : '48%',
    marginBottom: 14,
    borderWidth: 0.5,
    borderColor: '#e2e8f0',
    borderRadius: 10,
    overflow: 'hidden',
    backgroundColor: '#fff',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.08,
    shadowRadius: 3,
    elevation: 2,
  },
  listThumbnail: {
    width: '100%',
    height: 110,
    backgroundColor: '#f1f5f9',
  },
  listCardBody: {
    paddingHorizontal: 8,
    paddingTop: 8,
    paddingBottom: 4,
  },
  listCardTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: '#333',
  },
  listCardSubtitle: {
    fontSize: 10,
    color: '#94a3b8',
    marginTop: 2,
  },
  listCardActions: {
    flexDirection: 'row',
    padding: 6,
    gap: 6,
  },
  listActionButton: {
    flex: 1,
    paddingVertical: 6,
    borderRadius: 6,
    alignItems: 'center',
    justifyContent: 'center',
  },
  uploadActionButton: {
    backgroundColor: '#378ADD',
  },
  editActionButton: {
    backgroundColor: '#2E9E6C',
  },
  listActionButtonText: {
    color: '#fff',
    fontSize: 10,
    fontWeight: '600',
  },
  emptyListContainer: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 20,
    paddingVertical: 30,
    alignItems: 'center',
  },
  emptyListText: {
    fontSize: 13,
    color: '#94a3b8',
  },

  treeSection: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 8,
    marginBottom: 30,
  },
  treeHintText: {
    fontSize: 11,
    color: '#94a3b8',
    marginBottom: 10,
  },
  treeSearchButton: {
    backgroundColor: '#007bff',
    paddingVertical: 8,
    paddingHorizontal: 18,
    borderRadius: 4,
    alignSelf: 'flex-start',
    marginBottom: 16,
  },
  treeColumnsRow: {
    flexDirection: isWideWeb ? 'row' : 'column',
    gap: 12,
  },
  treeColumn: {
    flex: 1,
    backgroundColor: '#f8fafc',
    borderRadius: 10,
    padding: 10,
    minWidth: isWideWeb ? 0 : '100%',
  },
  treeColumnTitle: {
    fontSize: 13,
    fontWeight: '700',
    marginBottom: 10,
    paddingHorizontal: 2,
  },
  treeColumnTitleGreen: {
    color: '#2E9E6C',
  },
  treeColumnTitleRed: {
    color: '#A32D2D',
  },
  treeEmptyText: {
    fontSize: 12,
    color: '#94a3b8',
    paddingHorizontal: 2,
  },
  treeParentCard: {
    backgroundColor: '#fff',
    borderRadius: 8,
    borderWidth: 0.5,
    borderColor: '#e2e8f0',
    marginBottom: 8,
    overflow: 'hidden',
  },
  treeParentRow: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
    gap: 8,
  },
  treeParentTitle: {
    fontSize: 13,
    fontWeight: '600',
    color: '#333',
  },
  treeParentSubtitle: {
    fontSize: 11,
    color: '#94a3b8',
    marginTop: 2,
  },
  treeExpandIcon: {
    fontSize: 12,
    color: '#64748b',
    marginHorizontal: 6,
  },
  treeUploadButton: {
    backgroundColor: '#378ADD',
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 6,
  },
  treeUploadButtonText: {
    color: '#fff',
    fontSize: 10,
    fontWeight: '600',
  },
  treeChildrenWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    padding: 10,
    paddingTop: 0,
    borderTopWidth: 0.5,
    borderTopColor: '#e2e8f0',
  },
  treeChildCard: {
    width: 90,
    borderWidth: 0.5,
    borderColor: '#e2e8f0',
    borderRadius: 6,
    overflow: 'hidden',
    backgroundColor: '#fff',
  },
  treeChildThumb: {
    width: '100%',
    height: 70,
    backgroundColor: '#f1f5f9',
  },
  treeChildName: {
    fontSize: 9,
    color: '#64748b',
    paddingHorizontal: 4,
    paddingTop: 4,
  },
  treeChildEditButton: {
    backgroundColor: '#2E9E6C',
    marginHorizontal: 4,
    marginVertical: 4,
    paddingVertical: 3,
    borderRadius: 4,
    alignItems: 'center',
  },
  treeChildEditButtonText: {
    color: '#fff',
    fontSize: 9,
    fontWeight: '600',
  },
  // Chief Court specific styles
  treeDiaryCard: {
    backgroundColor: '#f1f5f9',
    borderRadius: 6,
    marginBottom: 6,
    overflow: 'hidden',
    width: '100%',
  },
  treeDiaryRow: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 8,
    gap: 8,
  },
  treeDiaryBadge: {
    color: '#2E9E6C',
    fontSize: 10,
    fontWeight: '600',
  },
  treeDiaryBadgeNo: {
    color: '#A32D2D',
    fontSize: 10,
    fontWeight: '600',
  },
  treeChildImagesWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    padding: 8,
    paddingTop: 0,
    borderTopWidth: 0.5,
    borderTopColor: '#e2e8f0',
  },
  // ... (rest of the styles remain same)
});

export default NonGRAllImageUploadComponent;